import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import cartReducer from "./slices/cartSlice";
import addressReducer from "./slices/addressSlice";
import contactsReducer from "./slices/contactsSlice";
import homeLookupsReducer from "./slices/homeLookupsSlice";
import incensesReducer from "./slices/incensesSlice";
import spicesReducer from "./slices/spicesSlice";
import orderPlacedReducer from "./slices/orderPlacedSlice";
import loaderReducer from "./slices/loaderSlice";
import rootSaga from "./sagas/rootSaga";
import myOrdersReducer from "./slices/myOrdersSlice";

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    cart: cartReducer,
    address: addressReducer,
    contacts: contactsReducer,
    homeLookups: homeLookupsReducer,
    incenses: incensesReducer,
    spices: spicesReducer,
    orderPlaced: orderPlacedReducer,
    loader: loaderReducer,
    myOrders: myOrdersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
